import RenderFiles from './RenderFiles';

export default RenderFiles;
